import { Component, OnInit } from '@angular/core';
import {EventsService} from '../_services/events.service';
import {LayersService} from '../_services/layers.service';
import { ExportService } from '../_services/export.service';


@Component({
    selector: 'app-selected-layers-detail-view',
    templateUrl: './selected-layers-detail-view.component.html',
    styleUrls: ['./selected-layers-detail-view.component.css'],
    standalone: false
})
export class SelectedLayersDetailViewComponent implements OnInit {

  nodes:any[] = [];  

 
  constructor(private es:EventsService,private ls:LayersService, private exportService: ExportService) { }

  public hide(node: any) {
    node.data.ison = node.data.ison === undefined ? false : !node.data.ison;
    node.data.aclass = node.data.ison ? 'activeLayer' : 'notActiveLayer';

    this.es.sendTreeNodeOnOffEvt({
        ...node.data,
        visibilityOnly: true
    });
    }
  
  public remove(event: any, node: any) {
    event.stopPropagation();

    node.data.ison = false;
    node.data.removeLayerDetailView = true;
    node.data.aclass = 'notActiveLayer';

    const idx = this.nodes.findIndex(n => n?.data?.id === node?.data?.id);
    if (idx >= 0) {
        this.nodes.splice(idx, 1);
    }

    this.es.sendTreeNodeOnOffEvt({
        id: node.data.id,
        ison: false,
        removeFromTree: true
    });

    this.es.sendUnSelectNode(node);
    this.es.setVisibleLegendsEvt(this.nodes.length);
  }
    
  public onClose(node:any)
  {
     this.hide(node); 
  }
  
  public onOpen(node: any)
  {
      this.hide(node); 
  }
  
  public setHiddenLegend(v:boolean)
  {
     
       this.es.setVisibleLegendsEvt(v);
     
  }
  
  ngOnInit() 
  {
  
      this.ls.subscribeLayersGroupLoadListener().subscribe(data=>{
          
          if (data.ob_mid !== undefined)
          {
              
              this.nodes = [];
              
          }    
          
      });
      
      this.es.subscribeNodeSelectListener().subscribe(node=>{
          
          if (!this.exists(node) && node.data.showlegend !== undefined && node.data.showlegend)
          {    
              node.data.ison = true;
              node.data.removeLayerDetailView = false;
              node.data.aclass = "activeLayer";
              this.nodes.push(node);
              this.es.setVisibleLegendsEvt(this.nodes.length);
          
          }
          
      });
      
    this.es.subscribeNodeUnSelectListener().subscribe((node: any) => {
        const id = node?.data?.id;
        if (id == null) {
            return;
        }

        const idx = this.nodes.findIndex(n => n?.data?.id == id);
        if (idx >= 0) {
            this.nodes[idx].data.aclass = 'notActiveLayer';
            this.nodes.splice(idx, 1);
            this.es.setVisibleLegendsEvt(this.nodes.length);
        }
    });
  }

  public exists(node:any)
  {
      var e:boolean = false;
      for (let n of  this.nodes)
      {
          
          if (n.data.id == node.data.id )
          {
             
              e = true;
            
             
          }    
        
      }    
      return e;
  }

  public canExport(node: any): boolean {
    return this.exportService.canExport(node);
  }

  public doExport(event: any, node: any, format: 'gpkg' | 'tif'): void {
    event.stopPropagation();
    this.exportService.run(node, format);
  }
  
}
